import {Injectable} from '@angular/core';
import {Bankverbindung, KontoinhaberEnumLabels, StammdatenBankverbindung} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class BankverbindungMapperService extends AbstractMapper<StammdatenBankverbindung, Bankverbindung> {

  public getMappedArrayDefaultIndex(source: Array<StammdatenBankverbindung>): number {
    return source.findIndex((item: StammdatenBankverbindung) => item.standard);
  }

  protected mapInternal(source: StammdatenBankverbindung): Bankverbindung {

    return {
      iban: source.iban,
      bic: source.bic,
      abweichenderKontoinhaber: source.abweichenderKontoinhaber,
      kontoinhaber: !!source.abweichenderKontoinhaber ? KontoinhaberEnumLabels._99 : KontoinhaberEnumLabels._1,
      bezeichnung: source.bezeichnung
    };
  }
}
